module.exports = __webpack_public_path__ + "img/定额库@3x.png";